const BASE_URL = "/recompensa";

const routesRecompensa = [
  {
    path: `${BASE_URL}/validar`,
    name: "home-recompensa-validate",
    meta: { title: "Validar", icon: "check", sidebar: true },
    component: () => import("../views/validador/validate/Validate.vue")
  },
  {
    path: `${BASE_URL}/historial/recompensa`,
    name: "order-recompensa",
    meta: { title: "Recompensa", icon: "gift", sidebar: true },
    component: () => import("../views/validador/order/OrderRecompensa.vue")
  },
  {
    path: `${BASE_URL}/empresas`,
    name: "validate-document",
    meta: { title: "Empresas", icon: "calendar", sidebar: false },
    component: () =>
      import("../views/validador/validate/CompanyProviderList.vue")
  },
  {
    path: `${BASE_URL}/empresas/:company_provider_id/productos`,
    name: "validate-product-list",
    meta: { title: "Productos", sidebar: false },
    component: () => import("../views/validador/validate/ProductList.vue")
  },
  {
    path: `${BASE_URL}/empresas/:company_provider_id/validar/:product_id`,
    name: "validate-product",
    meta: { title: "Productos", sidebar: false },
    component: () => import("../views/validador/validate/ValidateForm.vue")
  }
];

export default routesRecompensa;
